import { concat } from 'ramda';
import subscriptionApi from '../subscriptionApi';

const getUrl = concat('subscription-plans/');

const enrollmentEndpoints = subscriptionApi.injectEndpoints({
  endpoints: ({ query }) => ({
    getGlobalCustomers: query({
      query: () => ({
        url: getUrl('get-user-affiliate-global-customers'),
      }),
    }),
  }),
});

// eslint-disable-next-line import/prefer-default-export
export const { useGetGlobalCustomersQuery } = enrollmentEndpoints;
